module.exports = __webpack_public_path__ + "img/1440.2cffcc32.jpg";